import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLockOpen = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-lock-keyhole-open",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 16,
			r: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 12,
			x: 3,
			y: 10,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5" })
	]
});
export default SvgLockOpen;
